import React from 'react';

import { FormRefsContext } from './form-refs.context';
import { FormRefsContextProps } from './form-refs-context-props';

export function FormFieldsRefsProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const fieldsRefs = React.useRef<Record<string, HTMLElement>>({});
  const formReference = React.createRef<HTMLFormElement>();

  return (
    <FormRefsContext.Provider
      value={
        {
          fieldsRefs,
          formReference
        } as FormRefsContextProps
      }
    >
      {children}
    </FormRefsContext.Provider>
  );
}
